<template lang="pug">
SspLayout(area="core")
  template(slot="actions")
    form.search.input-group(@submit.prevent="$router.push({ name: 'order', params: {id: orderId}})")
      input.form-control.order-input(v-model="orderId" placeholder="Go to order")
      span.input-group-btn
        button.btn.btn-default.go-to-order-button(:disabled="!isValid")
          i.fa.fa-search
    .spacer
    router-link.btn.btn-primary(:to="{name: 'orderCreate'}")
      i.fa.fa-plus
      span.ml5 New Order
    button.btn.btn-default.refresh.button(@click="$refs.grid.reload()")
      i.fa.fa-refresh
  DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
    tr(slot="thead")
      th ID
      th Name
      th Size
      th.hidden-xs Created
      th Product
      th.hidden-xs Locked
      th Owner
      th Organization
      th
    tr(v-for="order in orders")
      td {{order.id}}
      td {{order.description}}
      td {{order.size}}
      td.hidden-xs {{order.created | date}}
      td
        span(v-if="order.product") {{order.product.name}}
      td.hidden-xs
        i.fa(:class="order.lockedForExpansion ? 'fa-lock' : 'fa-unlock'")
      td
        span(v-if="order.createdBy") {{order.createdBy.username}}
      td
        span(v-if="order.createdBy && order.createdBy.organization") {{order.createdBy.organization.name}}
      td.actions
        a.btn-view(title="View order" @click="goToOrder(order.id)") View

</template>
<script>
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'
import { dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    orders: [],
    filter: '',
    orderId: null
  }),
  methods: {
    fetchData(page) {
      const req = page.pageRequest()
      return Core.listOrders(req)
        .then((resp) => {
          this.orders = resp.data.content
          return resp.data.totalElements
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    goToOrder(id) {
      this.$router.push(`/core/orders/order/${id}`)
    }
  },
  computed: {
    isValid() {
      return this.orderId
    }
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter
  }
}
</script>
<style lang="scss">
.search.input-group {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/Orders.vue